"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widthToHeightRatio = exports.maxMDContainerHeight = exports.maxItemWidth = exports.maxItemHeight = exports.maxContainerWidth = exports.maxContainerHeight = exports.gapBig = exports.closeButtonFromRight = exports.arrowsPlusGapsBig = exports.arrowBig = void 0;
// mobile
const maxContainerHeight = exports.maxContainerHeight = 'calc(100vh - 45px)';

// MD up
const maxContainerWidth = exports.maxContainerWidth = 1244;
const maxMDContainerHeight = exports.maxMDContainerHeight = 590;
const maxItemWidth = exports.maxItemWidth = 1094;
const maxItemHeight = exports.maxItemHeight = 550;
const widthToHeightRatio = exports.widthToHeightRatio = maxItemWidth / maxItemHeight;
const arrowBig = exports.arrowBig = 45;
const gapBig = exports.gapBig = 30;
const arrowsPlusGapsBig = exports.arrowsPlusGapsBig = (arrowBig + gapBig) * 2;
const closeButtonFromRight = exports.closeButtonFromRight = arrowBig + gapBig + 5;
